import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import InverseModelDashboard from 'portal/src/pages/usage/InverseModelDashboard';
import isInverseModelDashboardEnabled from 'portal/src/pages/usage/isInverseModelDashboardEnabled';

import { RouteDefinition } from './routeGenerator';

export const usageRouteDefinitions: RouteDefinition[] = [
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ELECTRIC} />,
    name: 'Electric',
    path: NESTED_ROUTES.USAGE.ELECTRIC,
    description: 'Analyze calendar-normalized electric usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.GAS} />,
    name: 'Gas',
    path: NESTED_ROUTES.USAGE.GAS,
    description: 'Analyze calendar-normalized natural gas usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.WATER} />,
    name: 'Water',
    path: NESTED_ROUTES.USAGE.WATER,
    description: 'Analyze calendar-normalized water usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ALL_UTILITIES} />,
    name: 'All Utilities',
    path: NESTED_ROUTES.USAGE.ALL_UTILITIES,
    description: 'Analyze utility usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.YEAR_OVER_YEAR} />,
    name: 'Year-over-Year',
    path: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR,
    description: 'Analyze year-over-year usage',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.YEAR_OVER_YEAR_BAR} />
    ),
    name: 'Year-over-Year Bar',
    path: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR_BAR,
    description: 'Analyze year-over-year usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.TEMPERATURE} />,
    name: 'Temperature',
    path: NESTED_ROUTES.USAGE.TEMPERATURE,
    description: 'Examine how temperature impacts usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.WEATHER} />,
    name: 'Weather',
    path: NESTED_ROUTES.USAGE.WEATHER,
    description: 'Examine how weather correlates with usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ENERGY_KBTU} />,
    name: 'Energy (KBTU)',
    path: NESTED_ROUTES.USAGE.ENERGY_KBTU,
    description: 'Examine total energy usage in KBTU',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.USAGE.WEATHER_NORMALIZED_USAGE}
      />
    ),
    name: 'Weather Normalized Usage',
    path: NESTED_ROUTES.USAGE.WEATHER_NORMALIZED_USAGE,
    description: 'Analyze usage in relation to changes in weather',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.PROJECT_SAVINGS} />
    ),
    name: 'Project Savings',
    path: NESTED_ROUTES.USAGE.PROJECT_SAVINGS,
    description: 'Analyze project impacts with expected versus actual usage',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.DEMAND} />,
    name: 'Demand',
    path: NESTED_ROUTES.USAGE.DEMAND,
    description: 'Analyze billed and actual demand',
  },
  {
    element: (
      <InverseModelDashboard slug={DASHBOARD_SLUGS.USAGE.INVERSE_MODELS} />
    ),
    name: 'Inverse Models',
    path: NESTED_ROUTES.USAGE.INVERSE_MODELS,
    shouldRenderLink: isInverseModelDashboardEnabled,
    description:
      'Analyze inverse models for building performance opportunities',
  },
];
